var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE4\xBE\xA7\xE8\xBE\xB9\xE6\xA0\x8F/\xE5\x8E\xBB\xE5\xB1\x95\xE5\xBC\x80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9218 21.5984C10.4239 21.1004 10.4239 20.2932 10.9218 19.7952L16.2436 14.4734L10.9218 9.15153C10.4239 8.65361 10.4239 7.84632 10.9218 7.34841C11.4197 6.85049 12.227 6.85049 12.7249 7.34841L18.9391 13.5626C19.1904 13.8139 19.3149 14.1441 19.3125 14.4734C19.3149 14.8028 19.1904 15.1328 18.9391 15.3841L12.7249 21.5984C12.227 22.0963 11.4197 22.0963 10.9218 21.5984Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0a071b144fe4398702c4a8c0133dbe31.svg";
export { ForwardRef as ReactComponent };